import React, { useState, useEffect } from "react";
import { Autocomplete, CircularProgress } from "@mui/material";
import { searchFacility } from "../services/facility/facility";

const FacilityAutoSearch = ({
  label = "Search By ID or Name",
  value,
  onSelect,
  required = false,
  error = "",
  name = "facility",
}) => {
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [inputValue, setInputValue] = useState(value || "");

  useEffect(() => {
    if (inputValue.trim() === "") {
      setOptions([]);
      return;
    }

    const delayDebounceFn = setTimeout(async () => {
      setLoading(true);
      try {
        const dataRes = await searchFacility(inputValue);
        setOptions(dataRes || []);
      } catch (err) {
        console.error("Error fetching facilities:", err);
      } finally {
        setLoading(false);
      }
    }, 400);

    return () => clearTimeout(delayDebounceFn);
  }, [inputValue]);

  return (
    <div className="mb-2">
      <div className="position-relative">
        <Autocomplete
          freeSolo
          open={open}
          onOpen={() => setOpen(true)}
          onClose={() => setOpen(false)}
          options={options}
          loading={loading}
          value={
            typeof inputValue === "string"
              ? inputValue
              : inputValue?.Facility_Name || ""
          }
          getOptionLabel={(option) =>
            typeof option === "string" ? option : option.Facility_Name || ""
          }
          onInputChange={(event, newValue) => setInputValue(newValue)}
          onChange={(event, value) => {
            if (typeof value === "string") {
              setInputValue(value);
              onSelect({ Facility_Name: value, isManual: true });
            } else if (value && value.Facility_Name) {
              setInputValue(value.Facility_Name);
              onSelect(value);
            } else {
              setInputValue("");
              onSelect(null);
            }
          }}
          renderInput={(params) => (
            <div ref={params.InputProps.ref} className="position-relative">
              <input
                type="text"
                {...params.inputProps}
                id={name}
                name={name}
                required={required}
                className={`form-control ${error ? "is-invalid" : ""}`}
                placeholder={label}
                onBlur={() => {
                  if (
                    inputValue &&
                    !options.some((opt) => opt.Facility_Name === inputValue)
                  ) {
                    onSelect({ Facility_Name: inputValue, isManual: true });
                  }
                }}
              />
              {loading && (
                <div
                  className="position-absolute top-50 end-0 translate-middle-y me-3"
                  style={{ color: "#888" }}
                >
                  <CircularProgress size={16} />
                </div>
              )}
              {error && <div className="invalid-feedback d-block">{error}</div>}
            </div>
          )}
          sx={{
            "& .MuiInputBase-root": {
              height: "32px !important",
              fontSize: "0.8rem",
            },

            "& .MuiInputBase-input": {
              fontSize: "0.8rem",
              padding: "4px 8px !important",
            },
            "& .MuiAutocomplete-listbox": {
              padding: "0 !important",
              maxHeight: "180px",
            },
            "& .MuiOutlinedInput-notchedOutline": {
              borderRadius: "6px",
            },
            "& input::placeholder": {
              fontSize: "0.8rem",
              opacity: 0.7,
            },
          }}
        />
      </div>
    </div>
  );
};

export default FacilityAutoSearch;
